import styled from 'styled-components';

export const Container = styled.div`
  height: 64px;
  min-height: 64px;
  display: flex;
  align-items: center; 
  padding-inline: 20px;

  > div {
    width: 100%;
    overflow: hidden;
  }
  transition: 800ms;
`;
